module.exports = __webpack_public_path__ + "files/4ab434fc810b3b0dec2d746e756223f4.svg";